import { authProvider, getApiHeaders } from "../auth/authProvider";
import * as constants from "../constants/constants";
import { currentEnvironment } from "../utils/environment";
import { logMessage } from "../utils/Utils";

export function getJobsByOwner(owner, environment) {
  let options = {
    headers: {},
    method: "GET",
  };

  return getApiHeaders().then(
    (response) => {
      options.headers = response;

      let uri = new URL(`api/jobs/byownerwithpasswords?owner=${owner}`, environment.baseUrl);

      return fetch(uri, options)
        .then((response) => {
          if (response.status >= 400) {
            LogAndThrowError("Failed to retrieve topologies.", uri, response, environment);
          } else {
            return response.json();
          }
        })
        .then((json) => {
          return json;
        });
    },
    (error) => {
      LogAndThrowTokenError(error);
    },
  );
}

export function deleteTopology(topologyId, environment) {
  let options = {
    headers: {},
    method: "GET",
  };

  return getApiHeaders().then(
    (response) => {
      options.headers = response;

      let uri = new URL(`api/topology/checkin?topologyId=${topologyId}`, environment.baseUrl);

      return fetch(uri, options).then((response) => {
        if (response.status >= 400) {
          LogAndThrowError(`Unable to delete topology Id ${topologyId}`, uri, response, environment);
        } else {
          logMessage(constants.LOG_LEVEL.CONSOLE_ONLY, `Deleted topology Id: ${topologyId}`);
        }
      });
    },
    (error) => {
      LogAndThrowTokenError(error);
    },
  );
}

export function getAdminPassword(topologyTypeId, machineName, environment) {
  let options = {
    headers: {},
    method: "GET",
  };

  return getApiHeaders().then(
    (response) => {
      options.headers = response;

      let uri = new URL(
        `api/topology/vmadminpassword?topologyTypeId=${topologyTypeId}&machineName=${machineName}`,
        environment.baseUrl,
      );

      return fetch(uri, options)
        .then((response) => {
          if (response.status >= 400) {
            LogAndThrowError("Unable to retrieve password.", uri, response, environment);
          } else {
            return response.json();
          }
        })
        .then((json) => {
          return json;
        });
    },
    (error) => {
      LogAndThrowTokenError(error);
    },
  );
}

export function renameTopology(owner, id, newName, environment) {
  let options = {
    headers: {},
    method: "GET",
  };

  return getApiHeaders().then(
    (response) => {
      options.headers = response;

      let uri = new URL(`api/topology/rename?owner=${owner}&topologyId=${id}&newName=${newName}`, environment.baseUrl);

      return fetch(uri, options).then((response) => {
        if (response.status >= 400) {
          LogAndThrowError("Unable to rename topology", uri, response, environment);
        } else {
          logMessage(constants.LOG_LEVEL.CONSOLE_ONLY, "Rename topology");
        }
      });
    },
    (error) => {
      LogAndThrowTokenError(error);
    },
  );
}

export function transferOwnership(owner, id, newOwner, environment) {
  let options = {
    headers: {},
    method: "GET",
  };

  return getApiHeaders().then(
    (response) => {
      options.headers = response;

      let uri = new URL(
        `api/topology/transfer?owner=${owner}&topologyId=${id}&newOwner=${newOwner}`,
        environment.baseUrl,
      );

      return fetch(uri, options).then((response) => {
        if (response.status >= 400) {
          LogAndThrowError("Unable to transfer ownership of topology", uri, response, environment);
        } else {
          logMessage(constants.LOG_LEVEL.CONSOLE_ONLY, "Transfer ownership topology");
        }
      });
    },
    (error) => {
      LogAndThrowTokenError(error);
    },
  );
}

export function getTopologyById(topologyId, environment) {
  let options = {
    headers: {},
    method: "GET",
  };

  return getApiHeaders().then(
    (response) => {
      options.headers = response;

      let uri = new URL(`api/topology?id=${topologyId}`, environment.baseUrl);

      return fetch(uri, options)
        .then((response) => {
          if (response.status >= 400) {
            LogAndThrowError(`Unable to retrieve tasks for topology Id ${topologyId}`, uri, response, environment);
          } else {
            return response.json();
          }
        })
        .then((json) => {
          return json;
        });
    },
    (error) => {
      LogAndThrowTokenError(error);
    },
  );
}

export function resetTask(taskId, environment) {
  let options = {
    headers: {},
    method: "GET",
  };

  return getApiHeaders().then(
    (response) => {
      options.headers = response;

      let uri = new URL(`api/task/reset?taskId=${taskId}`, environment.baseUrl);

      return fetch(uri, options).then((response) => {
        if (response.status >= 400) {
          LogAndThrowError(`Unable to reset task Id ${taskId}`, uri, response, environment);
        } else {
          logMessage(constants.LOG_LEVEL.CONSOLE_ONLY, `Task reset. Id: ${taskId}`);
        }
      });
    },
    (error) => {
      LogAndThrowTokenError(error);
    },
  );
}

export function skipTask(taskId, environment) {
  let options = {
    headers: {},
    method: "GET",
  };

  return getApiHeaders().then(
    (response) => {
      options.headers = response;

      let uri = new URL(`api/task/skip?taskId=${taskId}`, environment.baseUrl);

      return fetch(uri, options).then((response) => {
        if (response.status >= 400) {
          LogAndThrowError(`Unable to skip task Id ${taskId}`, uri, response, environment);
        } else {
          logMessage(constants.LOG_LEVEL.CONSOLE_ONLY, `Task skipped. Id: ${taskId}`);
        }
      });
    },
    (error) => {
      LogAndThrowTokenError(error);
    },
  );
}

export function pauseTask(taskId, isPaused, environment) {
  let options = {
    headers: {},
    method: "GET",
  };

  let action = isPaused ? constants.PAUSE_RESUME.RESUME : constants.PAUSE_RESUME.PAUSE;

  return getApiHeaders().then(
    (response) => {
      options.headers = response;

      let uri = new URL(`api/task/pause?taskId=${taskId}&paused=${!isPaused}`, environment.baseUrl);

      return fetch(uri, options).then((response) => {
        if (response.status >= 400) {
          LogAndThrowError(`Unable to ${action} task Id ${taskId}`, uri, response, environment);
        } else {
          logMessage(constants.LOG_LEVEL.CONSOLE_ONLY, `Task ${action}d. Id: ${taskId}`);
        }
      });
    },
    (error) => {
      LogAndThrowTokenError(error);
    },
  );
}

export function getTaskLogs(taskId, environment) {
  let options = {
    headers: {},
    method: "GET",
  };

  return getApiHeaders().then(
    (response) => {
      options.headers = response;

      let uri = new URL(`api/logs?taskId=${taskId}`, environment.baseUrl);

      return fetch(uri, options)
        .then((response) => {
          if (response.status >= 400) {
            LogAndThrowError(`Unable to retrieve logs for task Id ${taskId}`, uri, response, environment);
          } else {
            return response.json();
          }
        })
        .then((json) => {
          return json;
        });
    },
    (error) => {
      LogAndThrowTokenError(error);
    },
  );
}

export function getPropertyBag(taskId, environment) {
  let options = {
    headers: {},
    method: "GET",
  };

  return getApiHeaders().then(
    (response) => {
      options.headers = response;

      let uri = new URL(`api/propertybag?taskId=${taskId}`, environment.baseUrl);

      return fetch(uri, options)
        .then((response) => {
          if (response.status >= 400) {
            LogAndThrowError(`Unable to retrieve property bag for task Id ${taskId}`, uri, response, environment);
          } else {
            return response.json();
          }
        })
        .then((json) => {
          return json;
        });
    },
    (error) => {
      LogAndThrowTokenError(error);
    },
  );
}

export function uploadPropertyBag(propertyBag, environment) {
  let options = {
    headers: {},
    method: "POST",
    body: JSON.stringify(propertyBag),
  };

  return getApiHeaders().then(
    (response) => {
      options.headers = response;

      let uri = new URL("api/propertybag/update", environment.baseUrl);

      return fetch(uri, options).then((response) => {
        if (response.status >= 400) {
          LogAndThrowError("Error updating PropertyBag.", uri, response, environment);
        } else {
          logMessage(constants.LOG_LEVEL.CONSOLE_ONLY, "Property bag saved.");
        }
      });
    },
    (error) => {
      LogAndThrowTokenError(error);
    },
  );
}

export function getTopologyTypes(environment) {
  let options = {
    headers: {},
    method: "GET",
  };

  return getApiHeaders().then(
    (response) => {
      options.headers = response;

      let uri = new URL("api/topologytype/enumerate", environment.baseUrl);

      return fetch(uri, options)
        .then((response) => {
          if (response.status >= 400) {
            LogAndThrowError("Unable to retrieve topology types.", uri, response);
          } else {
            return response.json();
          }
        })
        .then((json) => {
          return json;
        });
    },
    (error) => {
      LogAndThrowTokenError(error);
    },
  );
}

export function getGetCloudTypesDefaultClassic(environment) {
  let options = {
    headers: {},
    method: "GET",
  };

  return getApiHeaders().then(
    (response) => {
      options.headers = response;

      let uri = new URL("api/topology/defaultclassic", environment.baseUrl);

      return fetch(uri, options)
        .then((response) => {
          if (response.status >= 400) {
            LogAndThrowError("Failed to retrieve cloud types to default to classic", uri, response);
          } else {
            return response.json();
          }
        })
        .then((json) => {
          return json;
        });
    },
    (error) => {
      LogAndThrowTokenError(error);
    },
  );
}

export function checkoutTopology(topologyName, owner, topologyType, buildNumber, environment) {
  let options = {
    headers: {},
    method: "POST",
    body: JSON.stringify(topologyType),
  };

  return getApiHeaders().then(
    (response) => {
      options.headers = response;

      let uri = new URL(
        `api/topology/checkout?topologyName=${topologyName}&topologyOwner=${owner}&buildNumber=${buildNumber}&source=v2website`,
        environment.baseUrl,
      );

      return fetch(uri, options).then((response) => {
        if (response.status >= 400) {
          LogAndThrowError("Unable to submit topology.", uri, response);
        } else {
          logMessage(constants.LOG_LEVEL.CONSOLE_ONLY, "Topology submitted.");
        }
      });
    },
    (error) => {
      LogAndThrowTokenError(error);
    },
  );
}

export function deployTopologyTypeWithQueue(topologyArgs, environment) {
  topologyArgs.Source = "v2website";
  let options = {
    headers: {},
    method: "POST",
    body: JSON.stringify(topologyArgs),
  };

  return getApiHeaders().then(
    (response) => {
      options.headers = response;

      let uri = new URL("api/topologytype/deploywithqueue", environment.baseUrl);

      return fetch(uri, options)
        .then((response) => {
          if (response.status >= 400) {
            LogAndThrowError("Unable to submit topology with queue.", uri, response);
          } else {
            return response.json();
          }
        })
        .then((json) => {
          return json;
        });
    },
    (error) => {
      LogAndThrowTokenError(error);
    },
  );
}

export function uploadTemplate(partnerId, user, fileName, fileContent, environment) {
  let options = {
    headers: {},
    method: "PUT",
    body: fileContent,
  };

  return getApiHeaders().then(
    (response) => {
      options.headers = response;

      let uri = new URL(
        `api/template/upload?partnerTeamId=${partnerId}&user=${user}&fileName=${fileName}`,
        environment.baseUrl,
      );

      return fetch(uri, options)
        .then((response) => {
          if (response.status >= 400) {
            LogAndThrowError("Unable to upload template.", uri, response);
          } else {
            return response.json();
          }
        })
        .then((json) => {
          return json;
        });
    },
    (error) => {
      LogAndThrowTokenError(error);
    },
  );
}

export function uploadLookupFile(partnerId, user, fileName, fileContent, templatePath, environment) {
  let options = {
    headers: {},
    method: "PUT",
    body: fileContent,
  };

  return getApiHeaders().then(
    (response) => {
      options.headers = response;

      let uri = new URL(
        `api/lookupfile/upload?partnerTeamId=${partnerId}&user=${user}&fileName=${fileName}&rootpath=${templatePath}`,
        environment.baseUrl,
      );

      return fetch(uri, options)
        .then((response) => {
          if (response.status >= 400) {
            LogAndThrowError("Unable to upload lookup file.", uri, response);
          } else {
            return response.json();
          }
        })
        .then((json) => {
          return json;
        });
    },
    (error) => {
      LogAndThrowTokenError(error);
    },
  );
}

export function deployPrivateTemplate(topologyName, owner, path, userData, environment) {
  let options = {
    headers: {},
    method: "POST",
    body: JSON.stringify(userData),
  };

  return getApiHeaders().then(
    (response) => {
      options.headers = response;

      let uri = new URL(
        `api/template/deployprivate?name=${topologyName}&owner=${owner}&templatePath=${path}&regionId=${environment.regionId}&source=v2website`,
        environment.baseUrl,
      );

      let statusText;

      return fetch(uri, options)
        .then((response) => {
          if (response.status >= 400) {
            // For this only, need to get body text and handle error there
            statusText = response.statusText;
            return response.text();
          } else {
            logMessage(constants.LOG_LEVEL.CONSOLE_ONLY, "Private template submitted");
            return null;
          }
        })
        .then((bodyText) => {
          if (bodyText) {
            let message = "Unable to submit private template.";
            if (bodyText.indexOf("Invalid Picker Node") > -1) {
              message += `\n${bodyText} A list of valid queries is at:\n${statusText}`;
            } else {
              message += `\n${bodyText}`;
            }
            LogAndThrowError(message, uri, null);
          }
        });
    },
    (error) => {
      LogAndThrowTokenError(error);
    },
  );
}

export function deployLookupTopologyType(lookupTopologyArgs, environment) {
  lookupTopologyArgs.Source = "v2website";
  lookupTopologyArgs.LookupTopologyType.RequestRegionId = environment.regionId;
  let options = {
    headers: {},
    method: "POST",
    body: JSON.stringify(lookupTopologyArgs),
  };

  return getApiHeaders().then(
    (response) => {
      options.headers = response;

      let uri = new URL("api/lookuptopologytype/deploy", environment.baseUrl);

      return fetch(uri, options).then((response) => {
        if (response.status >= 400) {
          LogAndThrowError("Unable to submit topology.", uri, response);
        } else {
          logMessage(constants.LOG_LEVEL.CONSOLE_ONLY, "Topology submitted.");
        }
      });
    },
    (error) => {
      LogAndThrowTokenError(error);
    },
  );
}

export function getServiceStatus() {
  let options = {
    headers: {},
    method: "GET",
  };

  return getApiHeaders().then(
    (response) => {
      options.headers = response;

      let uri = new URL("api/servicestatus", currentEnvironment().baseUrl);
      return fetch(uri, options)
        .then((response) => {
          if (response.status >= 400) {
            logMessage(constants.LOG_LEVEL.CONSOLE_ONLY, "Unable to get service status.");
          } else {
            return response.json();
          }
        })
        .then((json) => {
          return json;
        });
    },
    (error) => {
      LogAndThrowTokenError(error);
    },
  );
}

export function getVisualStudioRemoteDebuggerPort(environment) {
  let options = {
    headers: {},
    method: "GET",
  };

  return getApiHeaders().then(
    (response) => {
      options.headers = response;

      let uri = new URL("api/topology/debugger", environment.baseUrl);
      return fetch(uri, options)
        .then((response) => {
          if (response.status >= 400) {
            logMessage(constants.LOG_LEVEL.CONSOLE_ONLY, "Unable to get debugger port.");
          } else {
            return response.json();
          }
        })
        .then((json) => {
          return json;
        });
    },
    (error) => {
      LogAndThrowTokenError(error);
    },
  );
}

export function logClientMessage(message, environment) {
  let options = {
    headers: {},
    method: "POST",
    body: JSON.stringify(message),
  };

  let uri = new URL("api/logging", (environment || currentEnvironment()).baseUrl);

  return getApiHeaders().then((response) => {
    options.headers = response;

    return fetch(uri, options).then((response) => {
      if (response.status >= 400) {
        logMessage(constants.LOG_LEVEL.CONSOLE_ONLY, "Unable to log error to server.");
      }
    });
  });
}

export function getMyQueueRequests(owner, environment) {
  let options = {
    headers: {},
    method: "GET",
  };

  return getApiHeaders().then(
    (response) => {
      options.headers = response;

      let uri = new URL(`api/queue/byowner?owner=${owner}`, environment.baseUrl);

      return fetch(uri, options)
        .then((response) => {
          if (response.status >= 400) {
            LogAndThrowError("Failed to retrieve queue requests.", uri, response, environment);
          } else {
            return response.json();
          }
        })
        .then((json) => {
          return json;
        });
    },
    (error) => {
      LogAndThrowTokenError(error);
    },
  );
}

export function cancelQueueRequest(workgroupId, environment) {
  let options = {
    headers: {},
    method: "POST",
  };

  return getApiHeaders().then(
    (response) => {
      options.headers = response;

      let uri = new URL(`api/queue/cancel/${workgroupId}`, environment.baseUrl);

      return fetch(uri, options).then((response) => {
        if (response.status >= 400) {
          LogAndThrowError(`Failed to cancel queue request for workgroupId: ${workgroupId}.`, uri, response, environment);
        } else {
          logMessage(constants.LOG_LEVEL.CONSOLE_ONLY, `Cancelled queue request for workgroupId: ${workgroupId}`);
        }
      });
    },
    (error) => {
      LogAndThrowTokenError(error);
    },
  );
}

function LogAndThrowTokenError(error, environment) {
  let message = constants.TOKEN_ERROR_MESSAGE;
  if (error && error.message && error.message !== "") {
    message += `\n${error.message}`;
  }

  LogAndThrowError(message, null, null, environment);
}

function LogAndThrowError(message, apiUri, response, environment) {
  if (response && response.status === 401) {
    window.alert(constants.UNAUTHORIZED_MESSAGE);
  }

  if (response && response.statusText && response.statusText !== "") {
    message += `\nStatus text: ${response.statusText}`;
  }
  logMessage(constants.LOG_LEVEL.ERROR, message, apiUri, environment);

  let error = new Error(message);
  throw error;
}

export function getDuplicateThresholdTopologies(environment) {
  let options = {
    headers: {},
    method: "GET",
  };

  return getApiHeaders().then(
    (response) => {
      options.headers = response;

      let uri = new URL("api/topology/getDuplicateThresholdTopologies", environment.baseUrl);

      return fetch(uri, options)
        .then((response) => {
          if (response.status >= 400) {
            LogAndThrowError("Unable to retrieve duplicate windows threshold topologies.", uri, response, environment);
          } else {
            logMessage(constants.LOG_LEVEL.CONSOLE_ONLY, "Retrieved the duplicate windows threshold topologies.");
            return response.json();
          }
        })
        .then((json) => {
          return json;
        });
    },
    (error) => {
      LogAndThrowTokenError(error);
    },
  );
}

function getGraphApiToken() {
  try {
    const accounts = authProvider.getAllAccounts();

    if (!accounts || accounts.length === 0) {
      return Promise.reject(new Error("No authenticated accounts found."));
    }

    const graphTokenRequest = {
      scopes: [constants.GRAPH_API_USER_READ_SCOPE],
      account: accounts[0]
    };

    return authProvider.acquireTokenSilent(graphTokenRequest)
      .then(tokenResponse => {
        return tokenResponse.accessToken;
      })
      .catch(() => {
        return authProvider.acquireTokenPopup(graphTokenRequest)
          .then(tokenResponse => {
            return tokenResponse.accessToken;
          });
      });
  } catch (error) {
    return Promise.reject(error);
  }
}

export function getUserRegion(environment) {
  return Promise.all([
    getApiHeaders(),
    getGraphApiToken()
  ]).then(([backendHeaders, graphToken]) => {
    if (!backendHeaders || !(backendHeaders instanceof Headers)) {
      return null;
    }

    const headerObj = {};
    backendHeaders.forEach((value, key) => {
      headerObj[key] = value;
    });

    const options = {
      headers: {
        ...headerObj,
        "X-Graph-Token": graphToken
      },
      method: "GET",
    };

    let uri = new URL("api/topology/getUserRegion", environment.baseUrl);

    return fetch(uri, options)
      .then((response) => {
        if (!response.ok) {
          var errorMessage = "Error occurred while trying to automatically retrieve user's region. Please select one manually.";

          return response.text().then(responseBody => {
            errorMessage += `\nAPI Response: ${responseBody}`;

            if (response.statusText && response.statusText !== "") {
              errorMessage += `\nStatus text: ${response.statusText}`;
            }

            logMessage(constants.LOG_LEVEL.ERROR, errorMessage, uri, environment);

            return {
              success: false,
              error: errorMessage,
              responseBody: responseBody
            };
          });
        } else {
          return response.json().then(data => {
            return {
              success: true,
              data: data
            };
          });
        }
      })
      .catch(error => {
        const errorMessage = "Error occurred while trying to automatically retrieve user's region. Please select one manually.";
        logMessage(constants.LOG_LEVEL.ERROR, `${errorMessage}\nNetwork error: ${error.message}`, uri, environment);

        return {
          success: false,
          error: errorMessage,
          responseBody: "Network or API communication error"
        };
      });
  })
    .catch((error) => {
      const errorMessage = "Error occurred while trying to automatically retrieve user's region. Please select one manually.";
      logMessage(constants.LOG_LEVEL.ERROR, `${errorMessage}\nToken/header error: ${error?.message || error}`, null, environment);
      return {
        success: false,
        error: errorMessage,
        responseBody: error?.message || "Token or header acquisition failed"
      };
    });
}